/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem,
    DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON,
    DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


